import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '@urc-ui/store/api/base';
import { getAdvertisingApiHeaders, getLocaleheader, getTimezoneHeader, resolveAdvertisingApiBaseUrl } from '@urc-ui/store/api/ross/utils';
import { HttpMethod, Tag } from '@urc-ui/store/api/types';
import { GetReportsRequest, GetReportsResponse } from '@urc-ui/store/api/ross/types/api-types';

export const rossReportsApi = createApi({
  reducerPath: 'rossReportsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: resolveAdvertisingApiBaseUrl()
  }),
  tagTypes: [Tag.REPORTS],
  endpoints: builder => ({
    getReports: builder.query({
      query: (request: GetReportsRequest) => {
        return {
          url: `/reports/subscriptions/${request.subscriptionId}/report?${buildGetReportsQueryParams(request)}`,
          method: HttpMethod.GET,
          headers: { ...getAdvertisingApiHeaders(), ...getLocaleheader(), ...getTimezoneHeader() }
        };
      },
      transformResponse: (response: any): GetReportsResponse => {
        return {
          reports: response?.reports,
          total: response?.total,
          nextToken: response?.nextToken
        };
      },
      providesTags: [Tag.REPORTS]
    })
  })
});

// Builds Query Parameters for Pagination for GetReports Requests
const buildGetReportsQueryParams = (request: GetReportsRequest): string => {
  const { pagination } = request;
  const queryParams: string[] = [];

  for (const [key, value] of Object.entries(pagination)) {
    if (value !== undefined && value !== null) {
      queryParams.push(`${key}=${encodeURIComponent(value)}`);
    }
  }
  return queryParams.join('&');
};

export const { useLazyGetReportsQuery } = rossReportsApi;
